class ContactLink {
    constructor( element ) {
        this.container = element;
        this.button = element.querySelector( '.contact-link__button' );
        this.menu = element.querySelector( '.contact-link__menu' );
        this.items = element.querySelectorAll( '.contact-link__item' );
        this.isOpen = false;

        this.init();
    }

    getFocusableItems() {
        return Array.from( this.items ).filter( ( item ) => {
            return item.offsetParent !== null && !item.hasAttribute( 'disabled' );
        } );
    }

    init() {
        if ( !this.button || !this.menu ) {return;}

        this.button.addEventListener( 'click', this.toggle.bind( this ) );

        this.menu.addEventListener( 'keydown', ( e ) => {
            const focusable = this.getFocusableItems();
            if ( !focusable.length ) {return;}

            const current = focusable.indexOf( document.activeElement );

            if ( e.key === 'ArrowDown' ) {
                e.preventDefault();
                const nextIndex = current === -1 ? 0 : ( current + 1 ) % focusable.length;
                focusable[ nextIndex ].focus();
                return;
            }

            if ( e.key === 'ArrowUp' ) {
                e.preventDefault();
                const prevIndex = current === -1
                    ? focusable.length - 1
                    : ( current - 1 + focusable.length ) % focusable.length;
                focusable[ prevIndex ].focus();
                return;
            }

            if ( e.key === 'Home' ) {
                e.preventDefault();
                focusable[ 0 ].focus();
                return;
            }

            if ( e.key === 'End' ) {
                e.preventDefault();
                focusable[ focusable.length - 1 ].focus();
                return;
            }

            if ( e.key === 'Tab' ) {
                this.close();
            }
        } );

        document.addEventListener( 'click', ( e ) => {
            if ( this.isOpen && !this.container.contains( e.target ) ) {
                this.close();
            }
        });

        document.addEventListener( 'keydown', ( e ) => {
            if ( this.isOpen && e.key === 'Escape' ) {
                this.close();
                this.button.focus();
            }
        });

        this.items.forEach( item => {
            item.addEventListener( 'click', () => {
                this.close();
            });
        });
    }

    toggle() {
        if ( this.isOpen ) {
            this.close();
        }
        else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        this.container.classList.add( 'contact-link--open' );
        this.button.setAttribute( 'aria-expanded', 'true' );
        this.button.setAttribute('aria-label', 'Kontaktmenü schließen');

        const focusable = this.getFocusableItems();
        if ( focusable[ 0 ]) {
            focusable[ 0 ].focus();
        }
    }

    close() {
        this.isOpen = false;
        this.container.classList.remove( 'contact-link--open' );
        this.button.setAttribute( 'aria-expanded', 'false' );
        this.button.setAttribute('aria-label', 'Kontaktmenü öffnen');
    }
}

export default ContactLink;
